<template>
  <div v-if="!loading">
    <div
      class="d-flex justify-content-between align-items-center flex-wrap px-sm-0 px-2"
    >
      <div>
        <h6>{{ exercise.title }}</h6>
      </div>
      <b-badge
        variant="light-danger"
        class="px-sm-3 py-sm-1 w-100"
        style="white-space: initial; line-height: 15px"
        v-if="exercise.has_answer"
      >
        <h4 class="text-danger mb-0 px-3 d-sm-flex d-none">
          شما به این تمرین پاسخ داده اید
        </h4>
        <h6 class="text-danger mb-0 px-sm-3 d-sm-none d-flex">
          شما به این تمرین پاسخ داده اید
        </h6>
      </b-badge>
      <span v-else
        ><timer
          :time="exercise.times.deadline_at"
          :type="2"
          v-model="deadlineAtTimer"
      /></span>
    </div>
    <div v-if="exercise.description">
      <b-badge variant="light-secondary" class="px-3 py-1 w-100">
        <div
          class="text-secondary mb-0"
          style="white-space: pre-wrap"
          v-html="exercise.description"
        ></div>
      </b-badge>
    </div>
    <div>
      <validation-observer ref="exerciseDone" #default="{ invalid }">
        <b-form @submit.prevent="exerciseDone" class="position-relative">
          <!-- <b-overlay
            variant="transparent"
            :opacity="1"
            blur="1px"
            :show="true"
            no-wrap
            v-if="!deadlineAtTimer.res"
          >
            <template v-slot:overlay>
              <div
                class="d-flex flex-column justify-content-center align-items-center"
              >
                <span class="h3 text-primary"
                  >زمان پاسخ گویی به اتمام رسیده است</span
                >
              </div>
            </template>
          </b-overlay> -->

          <div
            v-for="(question, qIndex) in exercise.questions.questions"
            :key="qIndex"
            class="my-2"
          >
            <h6>{{ question.question }}</h6>
            <div
              v-if="exercise.has_answer || !deadlineAtTimer"
              class="text-success"
            >
              <span>جواب صحیح : </span
              ><span>{{
                question.type == 2
                  ? question.response
                  : question.items.find((item) => item.is_correct == 1).value
              }}</span>
            </div>
            <div class="m-2" v-if="question.type == 0">
              <div class="m-1">
                <b-form-group label-for="option">
                  <div v-if="question.response">
                    <b-badge variant="light-secondary" class="py-50">
                      <div
                        class="text-secondary mb-0 w-100"
                        style="white-space: initial; line-height: 15px"
                        v-html="question.response"
                      ></div>
                    </b-badge>
                  </div>
                  <validation-provider
                    #default="{ errors }"
                    name="option"
                    vid="option"
                    rules="required"
                    class="d-flex flex-wrap"
                  >
                    <b-form-radio
                      :disabled="exercise.has_answer || !deadlineAtTimer"
                      v-for="(option, index) in question.items"
                      :key="index"
                      v-model="userAnswers[qIndex]"
                      :name="'correct-answer-' + exerciseIndex + qIndex"
                      :value="option"
                      class="mx-2 my-1"
                    >
                      {{ option.value }}
                    </b-form-radio>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </div>
            </div>
            <div class="m-2" v-else-if="question.type == 1">
              <div class="m-1">
                <b-form-group label-for="option">
                  <div v-if="question.response">
                    <b-badge variant="light-secondary" class="py-50">
                      <div
                        class="text-secondary mb-0 w-100"
                        style="white-space: initial; line-height: 15px"
                        v-html="question.response"
                      ></div>
                    </b-badge>
                  </div>
                  <validation-provider
                    #default="{ errors }"
                    name="option"
                    vid="option"
                    rules="required"
                    class="d-flex flex-wrap"
                  >
                    <b-form-radio
                      :disabled="exercise.has_answer || !deadlineAtTimer"
                      v-for="(option, index) in question.items"
                      :key="index"
                      v-model="userAnswers[qIndex]"
                      :name="'correct-answer-' + exerciseIndex + qIndex"
                      :value="option"
                      class="mx-2 my-1"
                    >
                      {{ option.value }}
                    </b-form-radio>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </div>
            </div>

            <div class="m-xl-2 m-0" v-else-if="question.type == 2">
              <div class="my-1">
                <b-form-group label-for="option" class="px-2">
                  <validation-provider
                    #default="{ errors }"
                    name="option"
                    vid="option"
                    rules="required"
                  >
                    <editor
                      v-if="deadlineAtTimer && !exercise.has_answer"
                      v-model="userAnswers[qIndex]"
                      :content="userAnswers[qIndex]"
                      autocomplete="on"
                      id="add-question-text"
                      name="add-question-text"
                      :state="errors.length > 0 ? false : null"
                    />
                    <!-- <b-form-file
                    browseText="آپلود فایل"
                    placeholder="فایلی انتخاب نشده است"
                    dropPlaceholder="فایل را در این محل رها کنید"
                    v-model="question.correctAnswer.file"
                    class="my-1 cursor-pointer"
                    accept="*"
                  /> -->
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </div>
            </div>
            <div class="m-2" v-else-if="question.type == 3">
              <div class="m-1">
                <b-form-group label-for="option">
                  <div v-if="question.response">
                    <b-badge variant="light-secondary" class="py-50">
                      <div
                        class="text-secondary mb-0 w-100"
                        style="white-space: initial; line-height: 15px"
                        v-html="question.response"
                      ></div>
                    </b-badge>
                  </div>
                  <validation-provider
                    #default="{ errors }"
                    name="option"
                    vid="option"
                    rules="required"
                    class="d-flex flex-wrap"
                  >
                    <b-form-radio
                      v-model="userAnswers[qIndex]"
                      :name="'correct-answer-' + exerciseIndex + qIndex"
                      :value="
                        question.items.find((item) => item.value == 'بله')
                      "
                      class="mx-2 my-1"
                      :disabled="exercise.has_answer || !deadlineAtTimer"
                    >
                      بله
                    </b-form-radio>
                    <b-form-radio
                      v-model="userAnswers[qIndex]"
                      :name="'correct-answer-' + exerciseIndex + qIndex"
                      :value="
                        question.items.find((item) => item.value == 'خیر')
                      "
                      class="mx-2 my-1"
                      :disabled="exercise.has_answer || !deadlineAtTimer"
                    >
                      خیر
                    </b-form-radio>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </div>
            </div>
          </div>
          <div
            class="w-100 d-flex justify-content-end m-xl-2 m-0 align-items-center"
          >
            <b-button
              v-if="deadlineAtTimer && !exercise.has_answer"
              class="mr-3"
              type="submit"
              :disabled="answerAll"
              :variant="answerAll ? 'secondary' : 'success'"
            >
              <span> ثبت پاسخ </span>
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </div>
    <b-modal
      hide-footer
      centered
      size="sm"
      v-model="visible"
      :title="exercise.title"
    >
      <div class="d-flex my-2 justify-content-between">
        <div class="d-flex text-success">
          <span>تعداد جواب صحیح : </span
          ><span>{{ totalAnswers.correctAnswers }}</span>
        </div>
        <div class="d-flex text-danger">
          <span>تعداد جواب غلط : </span
          ><span>{{ totalAnswers.falseAnswers }}</span>
        </div>
      </div>
      <div
        v-for="(question, index) in exercise.questions.questions"
        :key="index"
      >
        <h4>{{ question.question }}</h4>
        <div v-if="exercise.has_answer" class="text-success d-flex my-50">
          <span>جواب صحیح : </span
          ><span>{{
            question.type == 2
              ? question.response
              : question.items.find((item) => item.is_correct == 1).value
          }}</span>
        </div>
        <div v-if="exercise.has_answer" class="text-warning d-flex my-50">
          <span>جواب شما : </span>
          <span v-if="question.type == 2" v-html="userAnswers[index]"> </span>
          <span v-else-if="question.type == 3">{{
            userAnswers[index].value
          }}</span>
          <span v-else>{{
            userAnswers[index].value
              ? userAnswers[index].value
              : userAnswers[index]
          }}</span>
        </div>
        <hr
          class="my-1"
          v-if="index != exercise.questions.questions.length - 1"
        />
      </div>
    </b-modal>
    <loader :loading="loading" />
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BOverlay,
  BButton,
  BFormFile,
  BFormRadio,
  BForm,
  BBadge,
  BModal,
} from "bootstrap-vue";
import Editor from "@core/components/editor/Editor.vue";
import Timer from "@core/components/timer/Timer.vue";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import Loader from "@core/components/loader/Loader.vue";
let moment = require("jalali-moment");
export default {
  components: {
    BCard,
    BFormGroup,
    BOverlay,
    BButton,
    BFormFile,
    BFormRadio,
    Editor,
    Timer,
    AppTimeline,
    AppTimelineItem,
    ValidationProvider,
    ValidationObserver,
    Loader,
    BForm,
    BBadge,
    BModal,
  },
  props: {
    exercise: {
      type: Object,
      default: () => {},
    },
    exerciseIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      required,
      loading: false,
      userAnswers: [],
      totalAnswers: { correctAnswers: 0, falseAnswers: 0 },
      visible: false,
      deadlineAtTimer: true,
    };
  },
  async created() {
    let userAnswers = [];
    if (
      localStorage.getItem(
        `userAnswersForExercise${this.exercise.id}Course${this.$route.params.id}Session${this.$route.params.session_id}`
      )
    ) {
      userAnswers = JSON.parse(
        localStorage.getItem(
          `userAnswersForExercise${this.exercise.id}Course${this.$route.params.id}Session${this.$route.params.session_id}`
        )
      ).userAnswers;
    }
    if (
      this.exercise.has_answer &&
      userAnswers &&
      userAnswers.length &&
      userAnswers[0] !== ""
    ) {
      this.userAnswers = userAnswers;
      this.exercise.questions.questions.map((question, index) => {
        if (question.type == 2) {
          if (item == this.userAnswers[index]) {
            this.totalAnswers.correctAnswers++;
          } else {
            this.totalAnswers.falseAnswers++;
          }
        } else if (this.userAnswers[index].is_correct == "1") {
          this.totalAnswers.correctAnswers++;
        } else {
          this.totalAnswers.falseAnswers++;
        }
      });
      this.visible = true;
    } else {
      this.exercise.questions.questions.map((question) => {
        this.userAnswers.push("");
      });
    }
  },
  computed: {
    answerAll() {
      return this.userAnswers.findIndex((answer) => answer === "") > -1;
    },
  },
  watch: {
    visible(val) {
      if (!val) {
        localStorage.removeItem(
          `userAnswersForExercise${this.exercise.id}Course${this.$route.params.id}Session${this.$route.params.session_id}`
        );
      }
    },
  },
  methods: {
    timeStamp(val) {
      return this.getDifference(moment.utc(val).local().format("X"));
    },
    exerciseDone() {
      this.$refs.exerciseDone.validate().then(async (success) => {
        if (success && this.timeStamp(this.exercise.times.deadline_at).res) {
          localStorage.setItem(
            `userAnswersForExercise${this.exercise.id}Course${this.$route.params.id}Session${this.$route.params.session_id}`,
            JSON.stringify({
              id: this.exercise.id,
              userAnswers: this.userAnswers,
            })
          );
          this.loading = true;
          try {
            await this.exercise.questions.questions.map(
              async (question, index) => {
                await this.$http.post("/panel/answers", {
                  course_id: this.$route.params.id,
                  session_id: this.$route.params.session_id,
                  exercise_id: this.exercise.id,
                  question_id: question.id,
                  response:
                    question.type == 2
                      ? this.userAnswers[index]
                      : this.userAnswers[index].key,
                });
              }
            );
            this.$emit("getSession");
            this.$emit("getCourse");
          } catch (err) {}
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style></style>
